import styled from "styled-components";

export const HeaderContainer = styled.header`
  display: flex;
  align-items: center;
  padding: ${({ theme }) => `${theme.spacers["2M"]} ${theme.spacers.M}`};
  column-gap: ${({ theme }) => theme.spacers.M};
`;

export const HeaderTitle = styled.h1`
  ${({ theme }) => theme.typography.TinyHeadline};
  flex: 1;
`;
